import { createContext } from 'react';

import { QueryContextValueType } from './QueryContext.types';

export const QueryContext = createContext<QueryContextValueType | undefined>(undefined);
